import { render, staticRenderFns } from "./initialMail.vue?vue&type=template&id=1ba7f5b4&scoped=true"
import script from "./initialMail.vue?vue&type=script&lang=js"
export * from "./initialMail.vue?vue&type=script&lang=js"
import style0 from "./initialMail.vue?vue&type=style&index=0&id=1ba7f5b4&prod&lang=scss&scoped=true"
import style1 from "./initialMail.vue?vue&type=style&index=1&id=1ba7f5b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba7f5b4",
  null
  
)

export default component.exports